// 所有接口
import actions from '@/actions/index'
import { Base64 } from 'js-base64';
// import Vue from "vue/types/umd";

/***
 * 调取腾讯的人机验证
 * params{
 *  appId: 需要验证的 appId
 *  fn: 验证成功之后的回调
 * }
 *
 * ***/
export const isRobot = (appId, fn) => {
  let captcha = new TencentCaptcha(appId, (res) => {
    /* callback */
    if (res.ret === 0) {
      fn(res.randstr,res.ticket)
    }
  });
  captcha.show(); // 显示验证码
}

//删除cookies
export const delCookie = (name)=>{
  let { pathname, hostname } = window.location;
  var exp = new Date();
  exp.setTime(exp.getTime() -1);
  var cval=getCookie(name);
  if(cval!=null)
  document.cookie = `${name}=''; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${exp.toGMTString()};  path=/`
}
//【JWT】更新jwt时间
export const updateJWT = async (data,callback)=>{
  let { jwt, jwt_timestamp='' } = data;
  let { pathname, hostname } = window.location;
  let endData = new Date();
  if(jwt_timestamp){
    endData.setTime(jwt_timestamp*1000);//过期时间
  }else{
    jwt_timestamp = parseInt(new Date().getTime()/1000) + 14 * 24 * 60 * 60;
    endData.setTime(endData.getTime() + 14 * 24 * 60 * 60 * 1000);//过期时间 15天
  }
  document.cookie = `_t=${jwt}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  document.cookie = `_t_at=${jwt_timestamp}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  if(!jwt){
    document.cookie = `_t_plugin=${jwt}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
    document.cookie = `_t_plugin_at=${jwt_timestamp}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  }
  let user = get_tUser();
  localStorage.setItem('_c_t', user.c_t || '');
  callback && callback()
}
// 获取用户_t中的信息
export const get_tUser = (_t)=>{
  _t = _t || getCookie('_t'); //获取cookie中的_t
  let User = {};
  if(_t){
    let value = Base64.decode(_t.split('.')[1]);
    if(value){
      User = JSON.parse(value).User;
    }
  }
  return User;
}


//读取cookies
export const getCookie =(name)=>{
  let cookies = document.cookie.split(";");
  let cookiesObj = {}

  try {
    cookies.length && cookies.forEach(item=>{
      let items = item.split("=");
      let cookieValue = item.split(`${items[0]}=`)
      cookiesObj[items[0].trim()] = cookieValue[1] || items[1].trim();
    })
  } catch (error) { }
  
  if(name){
    return cookiesObj[name] || ''
  }
  return cookiesObj
}